export const DY_RETRY_COUNT = 2;

export const CHOOSE_ENDPOINT = '/v2/serve/user/choose';
export const ENGAGEMENT_ENDPOINT = '/v2/collect/user/engagement';

export const TYPE = {
    CART: 'CART',
    CATEGORY: 'CATEGORY',
    HOMEPAGE: 'HOMEPAGE',
    OTHER: 'OTHER',
    PRODUCT: 'PRODUCT',
} as const;

export const EMPTY_CART_DY_DATA = {
    selector: 'D - Empty Cart Rec New(100%)',
    type: TYPE.CART,
};
